import React, { ButtonHTMLAttributes, PropsWithChildren } from "react";

const Button : React.FC<PropsWithChildren<ButtonHTMLAttributes<{}>>> = ({children, className, disabled, ...props}) =>
    <button className={`btn btn-sm text-white ${disabled ? "bg-purple-800" : "bg-purple-600"} ${disabled ? "" : " hover:bg-purple-700"} `+(className??"")} disabled={disabled} {...props}>
        {children}
    </button>

export default Button;